export default __webpack_public_path__ + "acbe8a3085180acfb6b274163ce6c0a8.png";